export const EVENTS = {
  CATEGORIES_FILTER_TAGS: {
    CATEGORY_SELECTED: 'categories_filter_tags.category_selected',
    CATEGORY_DESELECTED: 'categories_filter_tags.category_deselected',
    FILTERS_UPDATED: 'categories_filter_tags.filters_updated'
  }
};

export const DEFAULT_STATE = {
  selectedCategories: [],
  filters: {}
};